<div class="">
    <!-- Header -->
    <div class="row mb-2">
        <div class="col-12">
            <h2 class="text-xl font-bold text-slate-800 tracking-tight">User Management</h2>
            <p class="text-xs text-muted mb-0">Manage system users, access roles, and platform permissions.</p>
        </div>
    </div>

    <!-- Users Tab Content -->
    <div class="animated fadeIn">
        <!-- Search -->
        <app-module-summary-bar [showPrimary]="isAdminOrIT" [autoLoadDashboard]="false" [items]="summaryItems"
            [primaryLabel]="'Add User'" [secondaryLabel]="'Export List'" (primaryClick)="openCreateUserModal()"
            (secondaryClick)="exportExcel()"></app-module-summary-bar>
        <div class="row align-items-center">
            <div class="col-md-6">
                <div style="min-width: 600px; max-width: 100%;">
                    <!-- Tier 5: wj-flex-grid-search replaced with the standard
                         app-search-input. The wrapper's [quickFilterText] input
                         drives the filtering on AG Grid side. -->
                    <app-search-input
                        [placeholder]="'🔍 Name, Email, Role'"
                        (searchChange)="onSearch($event)">
                    </app-search-input>
                </div>
            </div>
        </div>

        <!-- Loading State -->
        <div class="row mt-4 animated fadeIn" *ngIf="users.length === 0">
            <div class="col">
                <div class="alert alert-info text-center" role="alert" *ngIf="noUsersMessage !== 'No users found'">
                    <strong>Loading</strong>
                    <br>
                    <i class="fa fa-spinner fa-spin fa-2x mt-2"></i>
                    <br>
                    <span class="mt-2">Please wait</span>
                </div>
                <div class="alert alert-warning text-center" role="alert" *ngIf="noUsersMessage === 'No users found'">
                    <strong>{{noUsersMessage}}</strong>
                    <br>
                    <i class="fa fa-warning fa-2x"></i>
                </div>
            </div>
        </div>

        <!-- Users Grid -->
        <div class="row animated fadeIn mt-2">
            <div class="col-12">
                <div class="bg-card border border-border rounded-xl shadow-xs overflow-hidden">
                    <app-kite-grid
                        [columnDefs]="columnDefs"
                        [rowData]="pagedUsers"
                        [totalRecords]="filteredUsers.length"
                        [pageSize]="pageSize"
                        (pageChange)="onPageChange($event)"
                        (cellClicked)="onCellClicked($event)">
                    </app-kite-grid>
                </div>
            </div>
        </div>
    </div>
</div>
